module.exports = __webpack_public_path__ + "img/logoNew.fb8fee8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logoNew.png
// module id = ZV57
// module chunks = 136 171